export const VOWEL_MAP: { [key: string]: string } = {
  // First tone
  ā: "a",
  ē: "e",
  ī: "i",
  ō: "o",
  ū: "u",
  ǖ: "u",
  // Second tone
  á: "a",
  é: "e",
  í: "i",
  ó: "o",
  ú: "u",
  ǘ: "u",
  // Third tone
  ǎ: "a",
  ě: "e",
  ǐ: "i",
  ǒ: "o",
  ǔ: "u",
  ǚ: "u",
  // Fourth tone
  à: "a",
  è: "e",
  ì: "i",
  ò: "o",
  ù: "u",
  ǜ: "u",
};
